/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TOTPRegisterAttestationData } from './TOTPRegisterAttestationData';
import {
    TOTPRegisterAttestationDataFromJSON,
    TOTPRegisterAttestationDataFromJSONTyped,
    TOTPRegisterAttestationDataToJSON,
} from './TOTPRegisterAttestationData';

/**
 * 
 * @export
 * @interface TOTPRegisterAttestationAllOf
 */
export interface TOTPRegisterAttestationAllOf {
    /**
     * 
     * @type {TOTPRegisterAttestationData}
     * @memberof TOTPRegisterAttestationAllOf
     */
    data?: TOTPRegisterAttestationData;
}

/**
 * Check if a given object implements the TOTPRegisterAttestationAllOf interface.
 */
export function instanceOfTOTPRegisterAttestationAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TOTPRegisterAttestationAllOfFromJSON(json: any): TOTPRegisterAttestationAllOf {
    return TOTPRegisterAttestationAllOfFromJSONTyped(json, false);
}

export function TOTPRegisterAttestationAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterAttestationAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : TOTPRegisterAttestationDataFromJSON(json['data']),
    };
}

export function TOTPRegisterAttestationAllOfToJSON(value?: TOTPRegisterAttestationAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': TOTPRegisterAttestationDataToJSON(value.data),
    };
}

